// extracted by mini-css-extract-plugin
export var searchHeader = "_24-0";
export var searchHeaderDark = "_24-1";